import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CloseIcon, EventsIcon, TrophyIcon, TrashIcon } from '../../model/icons';
import LabeledInput from '../controls/LabeledInput';

const EMPTY_FORM = { title: '', startTime: '', useInTeamCompetition: false };

// Модалка создания/редактирования мероприятия.
export default function EventModal({ open, onClose, event, eventsState }) {
    const isEdit = Boolean(event?.id);
    const fileRef = useRef(null);

    const [form, setForm] = useState(EMPTY_FORM);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [imageDeleted, setImageDeleted] = useState(false);

    useEffect(() => {
        if (event) {
            setForm({
                title: event.title || '',
                startTime: event.startTime || '',
                useInTeamCompetition: event.useInTeamCompetition || false
            });
            setPreviewUrl(event.mediaFile?.mediaFileUrl || null);
        } else {
            setForm(EMPTY_FORM);
            setPreviewUrl(null);
        }
        setSelectedFile(null);
        setImageDeleted(false);
    }, [event, open]);

    if (!open) return null;

    const setField = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

    const handleFileSelect = (e) => {
        const file = e.target.files?.[0];
        if (file && file.type.startsWith('image/')) {
            setSelectedFile(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    const handleRemoveImage = () => {
        setSelectedFile(null);
        setPreviewUrl(null);
        if (event?.mediaFile?.mediaFileUrl) setImageDeleted(true);
    };

    const handleSave = async () => {
        try {
            if (imageDeleted && event?.id) await eventsState.deleteEventImage(event.id);
            await eventsState.saveEvent({
                ...(event || {}),
                title: form.title,
                startTime: form.startTime || null,
                useInTeamCompetition: form.useInTeamCompetition
            }, selectedFile);
            onClose();
        } catch (error) {
            // ошибка обработана в хуке
        }
    };

    const handleDelete = async () => {
        if (!event?.id) return;
        onClose();
        try {
            await eventsState.deleteEvent(event.id);
        } catch (error) {
            // ошибка обработана в хуке
        }
    };

    const datetimeValue = form.startTime ? form.startTime.slice(0, 16) : '';

    return (
        <div className="scrim show" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="modal" role="dialog" aria-modal="true">
                <div className="modal-head">
                    <div className="pl-head">
                        <span style={{ color: 'var(--accent)' }}><EventsIcon /></span>
                        <div className="mtitle">{isEdit ? 'Редактирование' : 'Новое мероприятие'}</div>
                    </div>
                    <button type="button" className="x-btn" onClick={onClose} aria-label="Закрыть"><CloseIcon /></button>
                </div>

                <div className="modal-body">
                    <input type="file" accept="image/*" ref={fileRef} onChange={handleFileSelect} style={{ display: 'none' }} />

                    <LabeledInput
                        className="set-field"
                        label="Название мероприятия"
                        value={form.title}
                        onChange={(e) => setField('title', e.target.value)}
                    />

                    <div className="set-field">
                        <label className="ctl-label">Дата и время</label>
                        <input
                            className="input"
                            type="datetime-local"
                            value={datetimeValue}
                            onChange={(e) => setField('startTime', e.target.value ? `${e.target.value}:00` : '')}
                        />
                    </div>

                    <div>
                        <label className="ctl-label">Картинка мероприятия</label>
                        <div className="ev-imgbox" onClick={() => fileRef.current?.click()}>
                            {previewUrl ? (
                                <>
                                    <img src={previewUrl} alt="" />
                                    <button
                                        type="button"
                                        className="del"
                                        onClick={(e) => { e.stopPropagation(); handleRemoveImage(); }}
                                        aria-label="Удалить картинку"
                                    >
                                        <TrashIcon />
                                    </button>
                                </>
                            ) : (
                                <span className="ph"><EventsIcon /></span>
                            )}
                        </div>
                    </div>

                    <div
                        className={`ev-tg${form.useInTeamCompetition ? ' on' : ''}`}
                        onClick={() => setField('useInTeamCompetition', !form.useInTeamCompetition)}
                    >
                        <div className="lab"><TrophyIcon />Учитывать в командном зачёте</div>
                        <span className="sw" />
                    </div>
                </div>

                <div className="modal-foot">
                    {isEdit && <button type="button" className="btn btn-danger" onClick={handleDelete}>Удалить</button>}
                    <button type="button" className="btn btn-primary" onClick={handleSave} disabled={!form.title}>Сохранить</button>
                </div>
            </div>
        </div>
    );
}

EventModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    event: PropTypes.object,
    eventsState: PropTypes.shape({
        saveEvent: PropTypes.func.isRequired,
        deleteEvent: PropTypes.func.isRequired,
        deleteEventImage: PropTypes.func.isRequired
    }).isRequired
};

EventModal.defaultProps = { event: null };
